import Index from "../home/index"
export default function Dashboard(params) {
  return (
    <div>
      <Index />
    </div>
  );
}
